export default {
  BENCHMARK_SORT: 'BENCHMARK_SORT',
  BENCHMARK_PENDING: 'BENCHMARK_PENDING',
  BENCHMARK_COMPLETE: 'BENCHMARK_COMPLETE',
  BENCHMARK_ERROR: 'BENCHMARK_ERROR',
  BENCHMARK_CACHE_SAVE: 'BENCHMARK_CACHE_SAVE',
}